import useModalAside from '@use/useModalAside/useModalAside';
import { ref } from 'vue';
import FavouriteAside from '@components/Favourite/FavouriteAside.vue';

export default function useFavouriteModal() {
  const isOpen = ref(false);
  const modalAside = useModalAside();

  const open = (callBack?: () => unknown) => {
    modalAside.show(
      FavouriteAside,
      {},
      {
        afterRemove: () => {
          if (typeof callBack === 'function') {
            callBack();
          }
        },
      }
    );
    isOpen.value = true;
  };
  const close = async () => {
    // modalAside.hide();
    await modalAside.hide();
    isOpen.value = false;
  };
  return {
    // isOpen,
    open,
    close,
  };
}
